
@if (show) {
    <main class="agpr-userPreferences">
        <header>
            <h1 class="agpr-userPreferences-head">
                <span class="agpr-userPreferences-head-title"> {{ 'UserPreferences' | localize }} </span>
            </h1>
        </header>

        <div class="agpr-userPreferences-tabs">
            <agpr-tabs
                [selectedTabIndex]="selectedTabIndex"
                (selectedTabIndexChange)="tabIndexChange($event)"
                [useContentContainer]="false"
                (tabChange)="tabChange($event)"
                [tabsHeadingLevel]="3"
            >
                <agpr-tab
                    *ngIf="show"
                    [id]="tabIds.GENERAL"
                    [heading]="'UserPreferences.general'"
                >
                </agpr-tab>
                <agpr-tab
                    *ngIf="hasTargeting"
                    [id]="tabIds.DISCOVER"
                    [heading]="'UserPreferences.discover'"
                >
                </agpr-tab>
                <agpr-tab
                    *ngIf="hasMonitoring"
                    [id]="tabIds.MONITOR"
                    [heading]="'UserPreferences.monitor'"
                >
                </agpr-tab>
                <agpr-tab
                    *ngIf="hasReports"
                    [id]="tabIds.REPORT"
                    [heading]="'UserPreferences.report'"
                >
                </agpr-tab>
            </agpr-tabs>
        </div>

        <section class="agpr-userPreferences-main" [agprLoading]="loading">
            <div class="agpr-userPreferences-main-lhp">
                <agpr-scroll-panel>
                    <div class="agpr-userPreferences-main-lhp-content">
                        <div *ngIf="selectedTabId === tabIds.GENERAL">
                            <ng-container
                                *ngTemplateOutlet="list; context: {listItems: generalListItems}"
                            ></ng-container>
                        </div>
                        <div *ngIf="selectedTabId === tabIds.DISCOVER">
                            <ng-container
                                *ngTemplateOutlet="list; context: {listItems: discoverListItems}"
                            ></ng-container>
                        </div>
                        <div *ngIf="selectedTabId === tabIds.MONITOR">
                            <ng-container
                                *ngTemplateOutlet="list; context: {listItems: monitorListItems}"
                            ></ng-container>
                        </div>
                        <div *ngIf="selectedTabId === tabIds.REPORT">
                            <ng-container
                                *ngTemplateOutlet="list; context: {listItems: reportListItems}"
                            ></ng-container>
                        </div>
                    </div>
                </agpr-scroll-panel>
            </div>
            <div class="agpr-userPreferences-main-rhp">
                <agpr-scroll-panel #scrollPanel>
                    <div  class="agpr-userPreferences-main-rhp-content">
                        <agpr-general-preferences #generalPrefs
                            *ngIf="show && userAppPreferences && selectedTabId === tabIds.GENERAL"
                            [generalPrefs]="userAppPreferences.generalPrefs"
                            (childErrors)="onChildError($event)"
                            (removeErrors)="onChildRemoveError($event)"
                            (checkDirty)="updateDirtyFlag()"
                            (sectionListItems)="updateSectionListItems('generalListItems', $event)"
                        ></agpr-general-preferences>
                        <agpr-discover-user-preferences #targetingPrefs
                            *ngIf="hasTargeting && selectedTabId === tabIds.DISCOVER"
                            [discoverPreferences]="userAppPreferences.targetingPrefs"
                            (childErrors)="childErrors = $event"
                            (checkDirty)="updateDirtyFlag()"
                            (sectionListItems)="updateSectionListItems('discoverListItems', $event)"
                        ></agpr-discover-user-preferences>
                        <agpr-monitor-user-preferences #monitoringPrefs
                            *ngIf="hasMonitoring && selectedTabId === tabIds.MONITOR"
                            [monitoringPreferences]="userAppPreferences.monitoringPrefs"
                            (checkDirty)="updateDirtyFlag()"
                            (sectionListItems)="updateSectionListItems('monitorListItems', $event)"
                        ></agpr-monitor-user-preferences>
                        <agpr-report-user-preferences #reportPrefs
                            *ngIf="hasReports && selectedTabId === tabIds.REPORT"
                            [id]="id"
                            [reportPreferences]="userAppPreferences.reportsPrefs"
                            (checkDirty)="updateDirtyFlag()"
                            (sectionListItems)="updateSectionListItems('reportListItems', $event)"
                        ></agpr-report-user-preferences>
                    </div>
                </agpr-scroll-panel>
            </div>
        </section>
        <section
            class="agpr-userPreferences-footer"
            role="toolbar"
        >
            <agpr-action-bar>
                <ng-template #left>
                    <agpr-button
                        label="UserPreferences.reset"
                        [style]="buttonTypes.secondary"
                        (click)="resetUserPreferences()"
                    ></agpr-button>
                </ng-template>
                <ng-template #right>
                    @let firstChildError = this.childErrors[0];
                    @let saveButtonTooltip = firstChildError ? 'Account.save.resolveErrors' : (isDirty ? '' : 'Account.save.noChangesToSave');
                    <agpr-button
                        label="UserPreferences.update.save"
                        [disabled]="!isDirty"
                        [tooltip]="saveButtonTooltip"
                        tooltipPosition="left"
                        [ariaDescribedBy]="saveButtonTooltip"
                        (click)="saveChanges()"
                        [style]="buttonTypes.primary"
                    ></agpr-button>
                    @if (saveButtonTooltip) {
                        <span
                            [id]="saveButtonTooltip"
                            class="u-srOnly">
                            {{ saveButtonTooltip | localize}}
                        </span>
                    }
                </ng-template>
            </agpr-action-bar>
        </section>
    </main>
}

<ng-template #list let-listItems="listItems">
    <div class='agpr-userPreferences-main-lhp-listContainer'>
        <ul
            id="preferenceCategories"
            class="agpr-userPreferences-main-lhp-listContainer-list"
            agprListKeyboardNavigation
            [focusOnChild]="true"
        >
            <li
                *ngFor="let item of listItems; let i = index"
                id="leftSidebar.item_{{ i }}"
                class="agpr-userPreferences-main-lhp-listContainer-item"
                tabindex="0"
                (keydown)="scrollToSection(item.value, $event)"
                (click)="scrollToSection(item.value)"
            >
                <span class="agpr-userPreferences-main-lhp-listContainer-itemLabel">
                        {{ item.label | localize }}
                </span>
            </li>
        </ul>
    </div>
</ng-template>
